const options = {
    'select-promo-book': {
        minimumInputLength: 3,
    },
    'select-books': {
        minimumInputLength: 3,
    },
};

const paramsForAjaxCall = (params) => {
    return {
        s: params.term,
        action: 'search_woo_products',
    };
};

const setProducts = (data) => {
    return {
        results: data.data,
    };
};

const configureSelectField = (elementCssClass) => {
    const blocks = document.querySelectorAll(`.${elementCssClass}`);

    if (blocks) {
        blocks.forEach((block) => {
            block.classList.add('active');
        });
    }

    window.acf?.add_filter('select2_args', (args, $select) => {
        // settings, field, instance
        const newArgs = {};

        Object.assign(newArgs, args);

        Object.keys(options).forEach((optionKey) => {
            if ($select?.prevObject?.hasClass(optionKey)) {
                newArgs.ajax.data = paramsForAjaxCall;
                newArgs.ajax.processResults = setProducts;

                Object.assign(newArgs, options[optionKey]);
            }
        });

        return newArgs;
    });
};

export default configureSelectField;
